import {css} from '@emotion/css';
import {Alignment} from '../../../../types/index';

import {spacing, fonts} from '../../../../styles/js/variables';

const getAlignment = (alignment?: Alignment): string => {
  switch (alignment) {
    case Alignment.LEFT:
      return 'left';
    case Alignment.RIGHT:
      return 'right';
    case Alignment.CENTER:
      return 'center';
    default:
      return 'inherit';
  }
};

const styles = {
  header: (alignment?: Alignment): string => css`
    margin-top: 0;
    margin-bottom: ${spacing.XS};
    color: currentColor;
    font-weight: ${fonts.weight.SEMI_BOLD};
    line-height: ${fonts.lineHeight.HEADING};
    text-align: ${getAlignment(alignment)};
    label: ${alignment ? `header--${getAlignment(alignment)}` : 'header'};
  `,
};

export default styles;
